// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Poppins_170ae0', '__Poppins_Fallback_170ae0'"},"className":"__className_170ae0"};